
export const ENTITY__ACCOUNT = 'Account';
export const ENTITY__CANDIDATE = 'Candidate';
export const ENTITY__COMPANY = 'Company';
export const ENTITY__EMPLOYER = 'Employer';
export const ENTITY__ENGAGEMENT = 'Engagement';
export const ENTITY__JOB = 'Job';
export const ENTITY__RECRUITER = 'Recruiter';
export const ENTITY__SCHOOL = 'School';
